import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link, useParams, useLocation, json } from "react-router-dom";

import Breadcrumb from "../../component/breadcrumb/breadcrumb";
import HeroHomeAttendant from "../../component/Hero/HeroHomeAttendant";
import HospitalSlider from "../hospitalDetail/hospitalslider";
import BookTrick from "./booktricks";
import Mobile from "../../component/mobile/mobile";

import { PiGraduationCap } from "react-icons/pi";
import { CiLocationOn } from "react-icons/ci";
import { FaMoneyBill } from "react-icons/fa6";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Surgerybooking } from "../../env/action";
import { SurgeryDoctors } from "../../env/action";
import pilessurgery from "../../assets/pilessurgery.png";
import { UserContext } from "../../context/UserContext";


const SurgeryDetail = () => {
  const { hospitalId } = useParams();
  const location = useLocation();
  const surgeryId = location.state?.surgeryId;
  const [doctorList, setDoctorList] = useState([]);
  const [loading, setLoading] = useState(false);

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const dayAfter = new Date(today);
  dayAfter.setDate(today.getDate() + 2);

  const [selectedDate, setSelectedDate] = useState(today);
  const [calendarOpen, setCalendarOpen] = useState(false);

  const [selectedType, setSelectedType] = useState("self");
   const [fullname, setFullname] = useState("");
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [reason, setReason] = useState("");
   const { userData , token } = useContext(UserContext);
    const user = userData;

  const formatDate = (date, options) =>
    date.toLocaleDateString("en-US", options);
       useEffect(() => {
        if (!surgeryId) {
          return;
        }

        const fetchData = async () => {
          setLoading(true);

          const params = { surgery_id: surgeryId };
    
          SurgeryDoctors(params, (res) => {
            if (res.status === 1) {
              setDoctorList(res.data);
            } else {
              console.log("No Doctor found");
            }
            setLoading(false);
          });
        };

        fetchData();
      }, [surgeryId]);

     useEffect(() => {
      if (selectedType === "self" && user) {
        const fullAddress = `${user.address || ""}, ${user.locality || ""}, ${
          user.city || ""
        }, ${user.dist || ""}, ${user.state || ""}, ${user.pincode || ""}`;

        setFullname(user.name || "");
        setMobile(user.phone_number || "");
        setEmail(user.email || "");
        setAddress(fullAddress);
      } else {
        setFullname("");
        setMobile("");
        setEmail("");
        setAddress("");
      }
      setReason("");
    }, [selectedType, user]);



  return (
    <>
      <div className="pilessurgery">
        <div className="container">
          <Breadcrumb
            breadcrumbTitle="Piles Surgery"
            breadcrumbNav={[
              { navText: "Home", path: "/" },
              { navText: "Surgery", path: "/book-a-surgery" }
            ]}
          />
        </div>

        <HeroHomeAttendant img={pilessurgery} />

        <div style={{ backgroundColor: "#F9F9F9" }}>
          <Container>
            <p className="fs-2 fw-bolder text-dark mrgtp">Top Doctors</p>

            <Row>
              {/* LEFT SIDE DOCTOR CARDS */}
               <Col xl={8} lg={8} md={6} sm={12}>
    <Row className="g-3">

      {loading ? (
        <p>Loading...</p>
      ) : doctorList.length === 0 ? (
        <p>No Doctors Found</p>
      ) : (
        doctorList.map((doctor) => (
          <Col key={doctor.id} xl={4} lg={6} md={12}>
            <Card className="rounded-3" style={{ width: "100%" }}>
              
              {/* Doctor Image */}
              <Card.Img
                variant="top"
                src={doctor.image}
                style={{ height: "200px", objectFit: "cover" }}
              />

              <Card.Body>
                
                {/* Doctor Name */}
                <Card.Title className="fw-bolder">
                  {doctor.name}
                </Card.Title>

                {/* Experience */}
                <div className="d-flex">
                  <Card.Subtitle
                    className="text-primary"
                    style={{ fontSize: "12px" }}
                  >
                    {doctor.experience} Years Exp.
                  </Card.Subtitle>
                </div>

                {/* Qualification */}
                <div className="d-flex mt-1">
                  <PiGraduationCap className="me-2" />
                  <Card.Text style={{ fontSize: "12px" }}>
                    {doctor.qualification}
                  </Card.Text>
                </div>

                {/* Fees */}
                <div className="d-flex mt-1">
                  <FaMoneyBill className="me-2" />
                  <Card.Text style={{ fontSize: "12px" }}>
                    <span className="fw-bolder">₹ {doctor.fees}</span> at clinic
                  </Card.Text>
                </div>

                {/* Distance / Address */}
                <div className="d-flex mt-1">
                  <CiLocationOn className="me-2" />
                  <Card.Text style={{ fontSize: "12px" }}>
                    {doctor.dist}
                  </Card.Text>
                </div>

                  </Card.Body>
                </Card>
              </Col>
                ))
              )}

            </Row>
          </Col>


              {/* RIGHT SIDE FORM */}
              <Col xl={4} lg={4} md={6} sm={12}>
                <div className="form-section" style={{ maxWidth: "100%" }}>
                  <h3>Book a Appointment for Surgery</h3>

                  {/* Date Selection */}
                  <div className="date-selector">
                    <p className="label">Select a Date</p>

                    <div className="date-options">
                      {/* Today */}
                      <button
                        type="button"
                        className={`date-btn ${
                          selectedDate.toDateString() === today.toDateString() ? "active" : ""
                        }`}
                        onClick={() => setSelectedDate(today)}
                      >
                        <span>{formatDate(today, { day: "2-digit", month: "short" })}</span>
                        <small>Today</small>
                      </button>

                      {/* Tomorrow */}
                      <button
                        type="button"
                        className={`date-btn ${
                          selectedDate.toDateString() === tomorrow.toDateString()
                            ? "active"
                            : ""
                        }`}
                        onClick={() => setSelectedDate(tomorrow)}
                      >
                        <span>{formatDate(tomorrow, { day: "2-digit", month: "short" })}</span>
                        <small>Tomorrow</small>
                      </button>

                      {/* Day After */}
                      <button
                        type="button"
                        className={`date-btn ${
                          selectedDate.toDateString() === dayAfter.toDateString() ? "active" : ""
                        }`}
                        onClick={() => setSelectedDate(dayAfter)}
                      >
                        <span>{formatDate(dayAfter, { day: "2-digit", month: "short" })}</span>
                        <small>{formatDate(dayAfter, { weekday: "long" })}</small>
                      </button>

                      {/* Pick a Date */}
                      <button
                        type="button"
                        className={`date-btn ${calendarOpen ? "active" : ""}`}
                        onClick={() => setCalendarOpen(!calendarOpen)}
                      >
                        <span>Pick a</span>
                        <small>Date</small>
                      </button>
                    </div>

                    {/* Date Picker */}
                    {calendarOpen && (
                      <DatePicker
                        selected={selectedDate}
                        onChange={(date) => {
                          setSelectedDate(date);
                          setCalendarOpen(false);
                        }}
                        inline
                        minDate={new Date()}
                      />
                    )}

                    <p className="selected-date">
                      {formatDate(selectedDate, {
                        weekday: "long",
                        month: "long",
                        day: "numeric"
                      })}
                    </p>
                  </div>

                  {/* Choose Self/Other */}
                 <div className="choose-type">
                    <button
                      type="button"
                      className={`choose-btn ${selectedType === "self" ? "active" : ""}`}
                      onClick={() => setSelectedType("self")}
                    >
                      Self
                    </button>

                    <button
                      type="button"
                      className={`choose-btn ${selectedType === "other" ? "active" : ""}`}
                      onClick={() => setSelectedType("other")}
                    >
                      Others
                    </button>
                  </div>


                  {/* Appointment Form */}
                     <form
                  onSubmit={(e) => {
                    e.preventDefault();

                    const params = {
                      fullname,
                      mobile,
                      email,
                      address,
                      reason,
                      type: selectedType,
                      date: selectedDate,
                      surgery_id: surgeryId,
                      hospital_id: hospitalId,
                      source: "web",
                    };

                    Surgerybooking(params, token, (res) => {
                      if (!token) {
                        alert("Please login before Booking.");
                        return;
                      }
                    console.log("API RESPONSE =", res);

                    if (!res) {
                      alert("Server Error: No response received");
                      return;
                    }

                    if (res.status === 1) {
                      alert("Success: " + res.message);
                      window.location.reload();
                    } else {
                      alert("Error: " + res.message);
                    }
                  });

                  }}
                >
                  <input
                    type="text"
                    value={fullname}
                    onChange={(e) => setFullname(e.target.value)}
                    placeholder="Patient Name*"
                    required
                    readOnly={selectedType === "self"}
                  />

                  <input
                    type="tel"
                    value={mobile}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d{0,10}$/.test(val)) setMobile(val);
                    }}
                    placeholder="Mobile Number*"
                    required
                    readOnly={selectedType === "self"}
                  />

                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email Id"
                    required
                    readOnly={selectedType === "self"}
                  />

                  <input
                    type="text"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    placeholder="Address"
                    required
                    readOnly={selectedType === "self"}
                  />

                  <input
                    type="text"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Service Required"
                    required
                  />

                  <button type="submit" className="book-btn">
                    Book an Appointment
                  </button>
                </form>

                </div>
              </Col>
            </Row>
          </Container>

         
        </div>

        <BookTrick />
        <Mobile />
      </div>
    </>
  );
};

export default SurgeryDetail;
